<template>
  <div class="isolated-device-options">
    <div class="isolated-device-options__row">
      <div class="small-8 ">
        <label class="isolated-device-options__label">
          <input
            class="isolated-device-options__checkbox"
            type="checkbox"
            v-model="selectAllStatus"
            @click="() => selectAll()"
          >
          <div>{{ $t('action.selectAll') }}</div>
        </label>
      </div>
    </div>
    <div
      class="isolated-device-options__row"
      v-for="(item, key) in workPermitPreSetList"
      :key="key"
    >
      <div class="small-8 ">
        <label class="isolated-device-options__label">
          <input
            class="isolated-device-options__checkbox"
            type="checkbox"
            v-model="preSetCheckBox"
            :value="key"
          >
          <div>{{ item.text }}</div>
        </label>
      </div>
      <div class="small-10 isolated-device-options__input-box align-right">
        <input
          :disabled="getInputDisabledStatus(key)"
          class="isolated-device-options__input"
          v-if="item.showRemarks"
          v-model="preSetRemarks[key]"
          type="text"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import { ref, computed, unref } from 'vue-demi'
import { useStoreGetters } from '@/store/index'
import i18n from '@/utils/i18n'
import HKLCheckbox from '@/controls/Button/HKLCheckbox.vue'
import { useSelectAllButton } from './IsolatedDeviceOptions.hook'

export default {
  components: { HKLCheckbox },
  setup () {
    const preSetCheckBox = ref([])
    const preSetRemarks = ref({})
    const { currentRegion } = useStoreGetters('regions', ['currentRegion'])
    const workPermitPreSetList = computed(() => {
      return i18n.t(`workPermitPreSetList.${unref(currentRegion).name}`)
    })
    const [selectAllStatus, selectAll] = useSelectAllButton(workPermitPreSetList, preSetCheckBox)
    return {
      preSetCheckBox,
      preSetRemarks,
      workPermitPreSetList,
      selectAllStatus,
      selectAll,
      getInputDisabledStatus (key) {
        return !unref(preSetCheckBox).includes(key)
      },
      getRecommendation () {
        if (!unref(preSetCheckBox).length) return ''

        return sortBy(unref(preSetCheckBox))
          .map(selectedIndex => {
            const preSetItem = unref(workPermitPreSetList)[selectedIndex]
            const remarks = unref(preSetRemarks)[selectedIndex]
            return preSetItem.text + (remarks ? ` (${remarks})` : '')
          })
          .join('\n\r')
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.isolated-device-options {
  &__label {
    display: flex;
    align-items: baseline;
  }
  &__checkbox {
    margin-right: 5px;
    min-width: 14px;
  }
  &__row {
    min-height: 25px;
  }
  &__input-box {
    margin-bottom: 10px;
  }
  margin-bottom: 16px;
}
</style>
